import { carouselData, appData, mediaData, featuresData } from '@/mocks/homeData';

export function CarouselSection() {
  return (
    <section id="carousel" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
              <i className="ri-magic-line text-primary-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">焦点专题</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">深度策划的吃瓜专题，一次看过瘾</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
            {carouselData.map((item) => (
              <article key={item.id} className="group rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 overflow-hidden cursor-pointer flex flex-col">
                <div className="relative aspect-[5/3] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-3 md:p-4 flex-1 flex flex-col">
                  <p className="text-xs text-primary-500 font-medium mb-1 whitespace-nowrap">{item.subtitle}</p>
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="flex items-center gap-3 mb-2 justify-center lg:justify-start">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/30">
                  <i className="ri-smartphone-line text-primary-300 text-sm"></i>
                </span>
                <h2 className="text-lg md:text-xl font-heading text-background-50">下载APP</h2>
              </div>
              <p className="text-sm text-background-200/70 mb-4 md:mb-6 ml-0 lg:ml-11">{appData.description}</p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6 md:mb-8 ml-0 lg:ml-11">
                {appData.features.map((f) => (
                  <span key={f} className="flex items-center gap-1.5 text-xs text-background-200 bg-background-800 px-3 py-1.5 rounded-full whitespace-nowrap">
                    <i className="ri-check-line text-primary-400"></i>
                    {f}
                  </span>
                ))}
              </div>

              <div className="flex items-center justify-center lg:justify-start gap-4 ml-0 lg:ml-11">
                <div className="w-28 h-28 md:w-32 md:h-32 rounded-lg overflow-hidden bg-background-50 p-2">
                  <img src={appData.iosQr} alt="iOS下载二维码" className="w-full h-full object-contain" />
                </div>
                <div className="w-28 h-28 md:w-32 md:h-32 rounded-lg overflow-hidden bg-background-50 p-2">
                  <img src={appData.androidQr} alt="Android下载二维码" className="w-full h-full object-contain" />
                </div>
                <div className="hidden sm:flex flex-col gap-2">
                  <a href="#app" className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 hover:bg-background-100 text-foreground-800 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                    <i className="ri-apple-fill text-lg"></i>
                    App Store
                  </a>
                  <a href="#app" className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 hover:bg-background-100 text-foreground-800 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                    <i className="ri-android-fill text-lg"></i>
                    Android APK
                  </a>
                </div>
              </div>
            </div>

            <div className="flex-1 w-full max-w-sm lg:max-w-md">
              <div className="relative aspect-[9/16] max-h-[400px] rounded-2xl overflow-hidden border-4 border-background-700">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20mobile%20news%20app%20interface%20mockup%20with%20warm%20coral%20and%20dark%20theme%2C%20trending%20topics%20card%20layout%2C%20clean%20minimal%20UI%20design%2C%20Chinese%20language%20interface%20style%2C%20editorial%20news%20feed%20aesthetic%2C%20no%20real%20text%20readable%2C%20abstract%20design&width=600&height=1067&seq=app-preview&orientation=portrait"
                  alt="51吃瓜APP预览"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
              <i className="ri-play-circle-line text-accent-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">精彩视频</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">热门爆料视频解读，视觉化吃瓜体验</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {mediaData.map((item) => (
              <article key={item.id} className="group rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 overflow-hidden cursor-pointer">
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3">
                    <span className="px-2 py-0.5 text-xs font-semibold bg-background-900/80 text-background-50 rounded whitespace-nowrap">
                      {item.duration}
                    </span>
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 leading-snug">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.views}次播放
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100">
              <i className="ri-star-line text-secondary-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">平台优势</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">为什么选择51吃瓜每日大赛</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {featuresData.map((feature) => (
              <div key={feature.id} className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 group-hover:bg-primary-500 transition-colors mb-4">
                  <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
                </span>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">{feature.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}